import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, XCircle } from "lucide-react";
import { useCustomerAuth } from "@/context/CustomerAuthContext";

// Supabase's confirmation link lands here already signed in; anything else means the link was bad or old.
export default function VerifyEmail() {
  const { customer } = useCustomerAuth();
  const [timedOut, setTimedOut] = useState(false);
  const linkError = /error_description|error=/.test(window.location.hash + window.location.search);

  useEffect(() => {
    const t = setTimeout(() => setTimedOut(true), 6000);
    return () => clearTimeout(t);
  }, []);

  const status = customer && customer.verified ? "ok" : linkError || (timedOut && !customer) ? "fail" : "checking";

  return (
    <div className="max-w-md mx-auto px-5 py-24 min-h-[70vh] text-center" data-testid="verify-email-page">
      {status === "checking" && <p className="text-gray-400">Verifying your email...</p>}
      {status === "ok" && (
        <div data-testid="verify-success">
          <CheckCircle2 className="w-14 h-14 text-gold mx-auto" />
          <h1 className="font-serif text-3xl mt-5 text-charcoal">Email Verified</h1>
          <p className="text-gray-500 mt-3">Your account is now verified. Enjoy shopping with Zebaa.</p>
          <Link to="/account" className="inline-block mt-8 bg-pink text-white px-8 py-3.5 text-xs uppercase tracking-[0.18em] hover:bg-pink-hover transition-colors">Go to My Account</Link>
        </div>
      )}
      {status === "fail" && (
        <div data-testid="verify-fail">
          <XCircle className="w-14 h-14 text-gray-300 mx-auto" />
          <h1 className="font-serif text-3xl mt-5 text-charcoal">Link Invalid</h1>
          <p className="text-gray-500 mt-3">This verification link is invalid or has expired. Sign in and we'll send a fresh one.</p>
          <Link to="/login" className="inline-block mt-8 bg-pink text-white px-8 py-3.5 text-xs uppercase tracking-[0.18em] hover:bg-pink-hover transition-colors">Sign in</Link>
        </div>
      )}
    </div>
  );
}
